// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1748":"e4d37bdc","2015":"62030658","3006":"e4d37bdc","3767":"e4d37bdc","5152":"b69c9285","5520":"a60ccc05","6855":"e4d37bdc","8169":"a60ccc05","8579":"e4d37bdc"}[chunkId] + ".chunk.css";
};